import axios from 'axios';
import { Message } from 'element-ui';

axios.defaults.timeout = 10000
axios.defaults.withCredentials = true; // 允许跨域携带cookie
// 请求头信息是为post请求设置
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// axios.defaults.headers.post['ss-cookie'] = sessionStorage.getItem('token');

// post请求
export function request(url, params) {
    return new Promise((resolve, reject) => {
        // axios.post(url, QS.stringify(params))
        axios.post('/apis'+url, params, {})
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                console.log('========request请求失败   原因：=========', err)
                    // Message.error(err.data.message || 'request请求失败')
                reject('request请求失败===========', err.data)
                Message.error(err || 'request请求失败')
            })
    })
}


// 请求拦截器
// axios.interceptors.request.use(
//     config => {
//         config.headers['ss-cookie'] = sessionStorage.getItem('token');
//         return config;
//     },
//     error => {
//         return Promise.reject(error);
//     }
// )

// 响应拦截器
// axios.interceptors.response.use(response => {
//     if (response.status === 200) {
//         if (!response.data.status) {  
//             console.log('===========拦截器 200  status false   ===========',response.data)
//             Message.error(response.data.message || '请求返回false，已拦截')
//             if (response.data.code === 66) {
//                 console.log('用户未登录')
//             } else {

//             }
//         } else {  //请求成功，有数据返回
//             return Promise.resolve(response)  
//         }
//     } else {
//         console.log('===========拦截器  400  415===========',response)
//         error => {
//             console.log('调用失败')
//             Message.error(error || '调用失败')
//             return Promise.reject(error.response)
//         }
//     }
// })